import React from 'react';
import styled from 'styled-components';
import { Card, CardImage } from '../../styledComponents/theme';
import Link from 'gatsby-link'

const CardWrapper = styled.div`
  width: 33.3%;
  padding: 1%;
`;

const EpisodeCard = ({ episode }) => {
  if (episode) {
    return (
      <CardWrapper>
        <Link to={'/episode/' + episode.episodeId}>
          <Card>
            <CardImage src={[episode.posterUrl,"/img/episode_no_image.png"]} alt={episode.title} />
          </Card>
        </Link>
      </CardWrapper>
    );
  } else {
    return <div />;
  }
};

export default EpisodeCard;




// WEBPACK FOOTER //
// ./src/components/Episode/EpisodeCard.js